import { ElMessage, ElMessageBox } from "element-plus";
import {Component} from "vue";
import {Action, MessageBoxState} from "element-plus/es/components/message-box/src/message-box.type";

interface toastConfig {
    message: string,
    type?: "success" | "warning" | "error" | "info",
    icon?: string | Component,
    duration?: number,
    offset?: number
}

interface boxConfig {
    title: string,
    content: string,
    type?: "success" | "warning" | "error" | "info",
    icon?: string | Component,

    showCancelButton?: boolean,
    showConfirmButton?:boolean,
    cancelButtonText?: string,
    confirmButtonText?: string
}

export const toast = (config: toastConfig) => {
    return ElMessage({
        message: config.message,
        type: config?.type,
        plain: true,
        icon: config?.icon,
        customClass: "toast-mod",
        duration: config?.duration,
        showClose: false,
        offset: config?.offset,
        grouping: true,
        repeatNum: 1
    })
}

export const alert = (config: boxConfig) => {
    return ElMessageBox.alert(config.title, config.content, {
        type: config?.type,
        icon: config?.icon,
        customClass: "box-mod",
        showClose: false,
        cancelButtonClass: "box-cancel-btn",
        confirmButtonClass: "box-confirm-btn",
        closeOnClickModal: false,
        center: true,
        roundButton: true
    })
}

export const confirm = (config: boxConfig, beforeClose?: (action: Action, instance: MessageBoxState, done: () => void) => void) => {
    return ElMessageBox.confirm(config.content, config.title, {
        type: config?.type,
        icon: config?.icon,
        customClass: "box-mod",
        showClose: false,
        cancelButtonClass: "box-cancel-btn",
        confirmButtonClass: "box-confirm-btn",
        closeOnClickModal: false,
        center: true,
        roundButton: true,
        showCancelButton: config?.showCancelButton,
        showConfirmButton: config?.showConfirmButton,
        cancelButtonText: config?.cancelButtonText ? config?.cancelButtonText : '取消',
        confirmButtonText: config?.confirmButtonText ? config?.confirmButtonText : '确认',
        beforeClose
    })
}



